import src from "IMAGE";
export default { src, width: 3084, height: 3084, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAOUlEQVR42rWOwQkAMAgDk7r/zjXVSin49CCCOR8CjoE0kgsRy8ghS/yok4vRcFxrHdaYPahF/zy5bDKEAEj7RF6bAAAAAElFTkSuQmCC"};
